<template>
    <div class="switcher" id="switcher"></div>
</template>
<style lang="scss" scoped>
  .switcher {
    width: 1px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
  }
</style>
<script>
export default {
  data() {
    return {
      bottomReached: false,
      topReached: false,
      wheelEvent: false,
      wheelCount: 0,
    }
  },
  mounted() {
    this.$store.commit('setSwitcherRect');
    if (this.windowWidth > 768) {
      window.addEventListener('wheel', (e) => { this.handleWheel(e)}, false);
    }
  },
  computed: {
    windowHeight() {
      return this.$store.state.windowHeight;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    rect() {
      return this.$store.state.switcherRect;
    },
    scrolling() {
      return this.$store.state.scrolling;
    },
    sections() {
      return this.$store.state.sections
    }
  },
  methods: {
    handleWheel(ev) {
      this.$store.commit('setSwitcherRect');
      if (this.rect.top === 0) {
        this.topReached = true;
      } else {
        this.topReached = false;
      };
      if (this.rect.bottom <= this.windowHeight + 5) {
        this.bottomReached = true;
      } else {
        this.bottomReached = false;
      };
      if (
        ev.deltaY < 0
        && this.topReached
        && this.sections.counter > 0 
        && !this.scrolling
      ) {
        this.switcherFunction('up');
      } else if (
        ev.deltaY > 0
        && this.bottomReached
        && this.sections.counter < this.sections.array.length - 1
        && !this.scrolling
      ) {
        this.switcherFunction('down');
      }
    },
    switcherFunction(direction) {
      if (this.wheelCount < 5) {
        this.wheelCount += 1;
        if (this.wheelCount >= 5 && !this.scrolling) {
          this.$store.commit('setScrolling', true);
          switch (direction) {
            case 'down':
            this.$store.commit('setSectionAnim', 'section-up');
              this.$store.commit('setSectionCounter', 'up');        
              break;
            case 'up':
              this.$store.commit('setSectionAnim', 'section-down');
              this.$store.commit('setSectionCounter', 'down');        
              break;
            default:
              break;
          }
        }
      }
      setTimeout(() => {
        this.$store.commit('setScrolling', false);
        this.wheelCount = 0;
      }, 1500)
    }
  },
  beforeDestroy() {
    window.removeEventListener('wheel', (e) => {this.handleWheel(e)}, false);
  },
  watch: {
    windowWidth: function (newWidth) {
      if (newWidth <= 768) {
        window.removeEventListener('wheel', (e) => {this.handleWheel(e)}, false);
        this.wheelEvent = false;
      } else {
        if (!this.wheelEvent) {
          window.addEventListener('wheel', (e) => {this.handleWheel(e)}, false);
          this.wheelEvent = true;
        }
      }
    }
  }
}
</script>


